/* tslint:disable */
/* eslint-disable */
/**
 * CourierApi
 * CourierApi
 *
 * The version of the OpenAPI document: 2.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface NewRewardPrize
 */
export interface NewRewardPrize {
    /**
     * 
     * @type {number}
     * @memberof NewRewardPrize
     */
    pointsRequired?: number;
    /**
     * 
     * @type {string}
     * @memberof NewRewardPrize
     */
    name?: string;
    /**
     * 
     * @type {string}
     * @memberof NewRewardPrize
     */
    imageUrl?: string;
    /**
     * 
     * @type {string}
     * @memberof NewRewardPrize
     */
    description?: string;
    /**
     * 
     * @type {boolean}
     * @memberof NewRewardPrize
     */
    isActive?: boolean;
    /**
     * 
     * @type {number}
     * @memberof NewRewardPrize
     */
    courierId?: number;
}

/**
 * Check if a given object implements the NewRewardPrize interface.
 */
export function instanceOfNewRewardPrize(value: object): value is NewRewardPrize {
    return true;
}

export function NewRewardPrizeFromJSON(json: any): NewRewardPrize {
    return NewRewardPrizeFromJSONTyped(json, false);
}

export function NewRewardPrizeFromJSONTyped(json: any, ignoreDiscriminator: boolean): NewRewardPrize {
    if (json == null) {
        return json;
    }
    return {
        
        'pointsRequired': json['pointsRequired'] == null ? undefined : json['pointsRequired'],
        'name': json['name'] == null ? undefined : json['name'],
        'imageUrl': json['imageUrl'] == null ? undefined : json['imageUrl'],
        'description': json['description'] == null ? undefined : json['description'],
        'isActive': json['isActive'] == null ? undefined : json['isActive'],
        'courierId': json['courierId'] == null ? undefined : json['courierId'],
    };
}

export function NewRewardPrizeToJSON(json: any): NewRewardPrize {
    return NewRewardPrizeToJSONTyped(json, false);
}

export function NewRewardPrizeToJSONTyped(value?: NewRewardPrize | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'pointsRequired': value['pointsRequired'],
        'name': value['name'],
        'imageUrl': value['imageUrl'],
        'description': value['description'],
        'isActive': value['isActive'],
        'courierId': value['courierId'],
    };
}

